// extracted by mini-css-extract-plugin
module.exports = {"containerWidth":"34rem","mobileBreakpoint":"30rem","container":"style_container__TPfQM"};